import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
export class ProductDTO {
    @ApiProperty()
    @IsOptional()
    productId?: number;
    @ApiProperty()
    @IsNotEmpty({message:"Code not be empty"})
    productCode: string;

    @ApiProperty()
    @IsNotEmpty({message:"Name should not be empty"})
    productName: string;
    @ApiProperty()
    remarks: string;
    @ApiProperty()
    isActive: boolean;
    @ApiProperty()
    hsnCode: number;
    createdAt : Date;
    @ApiProperty()
    @IsOptional()
    @MaxLength(40, { message: "Created User allows maximum 40 characters" })
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })
    createdUser : string;

    updatedAt : Date;
    @ApiProperty()
    @IsOptional()
    @MaxLength(40, { message: "Updated User allows maximum 40 characters"})
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
    updatedUser : string;

    @ApiProperty()
    versionFlag : number;
}

